import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeader from "components/ViewHeader";
import ViewHeaderNavigation from "components/ViewHeader/Navigation";
import Box from "ds/components/Box";
import useTitle from "hooks/useTitle";
import Tab from "ds/components/Tab";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

import styles from "./styles.module.css";
import LaunchPadKnowledgeBase from "./KnowledgeBase";
import LaunchPadFAQ from "./FAQ";
import LaunchPadVideos from "./Videos";
import LaunchPadLearn from "./Learn";

const LaunchPadBoard = () => {
  useTitle("LaunchPad");

  const { viewer } = useTypedContext(AccountContext);

  return (
    <>
      <ViewHeader>
        <ViewHeaderTitle>
          <Box align="center" gap="medium">
            Welcome to LaunchPad
          </Box>
        </ViewHeaderTitle>
        {viewer.admin && (
          <ViewHeaderNavigation>
            <Tab to="/launchpad" end label="Learn" />
            <Tab to="/launchpad/track" label="Track" />
          </ViewHeaderNavigation>
        )}
      </ViewHeader>
      <Box grid gridTemplate="1fr" fullWidth>
        <Box
          className={styles.mainContainer}
          direction="column"
          gap="x-large"
        >
          <LaunchPadLearn />
          <LaunchPadKnowledgeBase />
          <LaunchPadVideos />
          <LaunchPadFAQ />
        </Box>
      </Box>
    </>
  );
};

export default LaunchPadBoard;
